/** Diálogo de confirmación global. Se monta una vez en App y lo usa useConfirm(). */
import { Modal } from './Modal';
import { useConfirmStore } from '@/hooks/useConfirm';

export function ConfirmDialog() {
  const { abierto, opciones, responder } = useConfirmStore();
  if (!opciones) return null;

  return (
    <Modal abierto={abierto} onCerrar={() => responder(false)} titulo={opciones.titulo} ancho="sm"
      pie={
        <div className="flex justify-end gap-2">
          <button onClick={() => responder(false)} className="rounded-lg border border-borde-fuerte px-4 py-2 text-sm dark:border-borde">
            {opciones.cancelar ?? 'Cancelar'}
          </button>
          <button onClick={() => responder(true)}
            className={`rounded-lg px-4 py-2 text-sm font-semibold ${opciones.peligro ? 'border border-peligro bg-peligro-suave text-peligro hover:bg-peligro-suave/80' : 'bg-primario text-primario-texto hover:bg-primario-fuerte'}`}>
            {opciones.confirmar ?? 'Confirmar'}
          </button>
        </div>
      }>
      <p className="text-sm text-texto-suave dark:text-texto-suave">{opciones.mensaje}</p>
    </Modal>
  );
}
